import React, { useEffect, useState, useRef } from "react";
import DataGrid from "../../../Js/Grid";
import letterOpen from "../../../Resources/Images/letterOpen.svg";
import letterClose from "../../../Resources/Images/letterClose.svg";
import arrow from "../../../Resources/Images/arrow.svg";
import "../../../Css/ListOfTickets.css";
import excel from "../../../Resources/Images/excel.svg";
import print from "../../../Resources/Images/print.svg";
import searchIcon from "../../../Resources/Images/searchIcon.svg";
import Search from "../../Search";
import NewTicket from "./NewTicket";
import { useNavigate, useLocation } from "react-router-dom";
import {
  CallService,
  CallServiceExternal,
  toElements,
  modalAlert,
  formatDate,
} from "../../../Js/Script.js";
import { SetUser, UseUser } from "../../../Js/Context/userCntx";
import { UseTicket, SetTicket } from "../../../Js/Context/TicketCntx";
import {
  UseOrganizaton,
  SetOrganizaton,
} from "../../../Js/Context/OrganizationCntx";
import { UseSearch, SetSearch } from "../../../Js/Context/SearchCntx";
import Pagination from "../../Pagination.jsx";
import { useReactToPrint } from "react-to-print";
export default function ListOfTickets(props) {
  const radisansupport = localStorage.getItem("radisan");
  const stSearch = UseSearch();
  const stOrganizaton = UseOrganizaton();
  const setStUseOrganizaton = SetOrganizaton();
  const { navbarItem } = props;
  const stUser = UseUser();
  const setStUser = SetUser();
  const ticket = UseTicket();
  const setTicket = SetTicket();
  const setStSearch = SetSearch();
  const [mainCategory, setMainCategory] = useState([]);
  const [tags, setTags] = useState([]);

  const idlocal = JSON.parse(localStorage.getItem("id"));

  const [states, setStates] = useState({
    Tickets: "",
    ShowSearchItems: false,
    //RowNum: "",
    Page: "tickets",
    status: "",
    reciverUser: [],
  });

  const inputRefs = {
    ListOfTickets: useRef(null),
    showPrintedList: useRef(null),
    dvImportant: useRef(null),
    User: useRef([]),
    uniqueUsers: useRef(new Set()),
  };
  const navigate = useNavigate();
  const location = useLocation();
  const showElement = [
    "SearchCategory",
    "SearchTitle",
    "SearchFrom",
    "SearchTill",
    "RegDateTime",
    "RegDateTimeTo",
    "UpdateDate",
    "UpdateDateTo",
    "TicketOwnerGroup",
    "TicketCreatedUser",
    "TicketRecipientGroup",
    "TicketReceivingUser",
    "TicketOwnerCompany",
    "TicketRecipientCompany",
    "TicketStatus",
    "Importance",
    "Satisfaction",
    "TicketVisibilityStatus",
    "answerStatus",
    "ticketId",
    "Tag",
  ];

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 12,
  });

  // async function handleLastPerson() {
  //   const result = await CallService(
  //     `TicketContent/GetLastMessageSenderId?ttId=${ticket.ticketId}`,
  //     null,
  //     "GET",
  //     false,
  //     false,
  //   );
  //   console.log("t", result);
  // }

  function handlePageChange(newPage) {
    setPagination((prev) => ({
      ...prev,
      currentPage: newPage,
    }));
    // // دریافت پارامترهای قبلی و اضافه کردن پارامترهای جدید
    // const params = new URLSearchParams(location.search);
    // params.set("page", newPage); // مقدار صفحه جدید
    // params.set("pageSize", pagination.pageSize); // اندازه صفحه
  }

  function getTags() {
    CallService("Tickets/GetTag", null, "GET", false, false)
      .then((res) => {
        setTags(res.tad);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getTags();
  }, []);

  function submitTag(ticketId, tagId) {
    CallService(
      `Tickets/SubmitTag?ticketId=${ticketId}&&tagId=${tagId}`,
      null,
      "PUT",
      false,
      false,
    )
      .then(() => {
        getListOfTickets(stSearch.searchedObject);
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });
  }

  function getListOfTickets(ListOfTickets = {}) {
    // if ( ListOfTickets && Object.keys(ListOfTickets).length == 0) {
    //   ListOfTickets.status =true
    // }
    // ListOfTickets = [...ListOfTickets, { status: true }];
    // console.log(ListOfTickets);
    // ListOfTickets.status = ListOfTickets && Object.keys(ListOfTickets).length == 0 ?true:;

    const { currentPage, pageSize } = pagination;
    const payload = {
      ...ListOfTickets,
      pageNumber: currentPage,
      pageSize: pageSize,
    };

    CallService(`Tickets/GetAllTicketsByAccess`, payload, "POST", false, false)
      .then((res) => {
        res.allTickets.tickets.sort(function (a, b) {
          return new Date(b.updateDateTime) - new Date(a.updateDateTime);
        });

        setTicket((prevState) => ({
          ...prevState,
          Tickets: res.allTickets.tickets,
          // Tickets: !isListEmpty ? res.allTickets.tickets
          // .filter(x=>x.status) : res.allTickets.tickets,
        }));
        setPagination((prev) => ({
          ...prev,
          totalPages: res.allTickets.totalCount || 0, // Assume `totalRecords` is sent by the backend
        }));
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });

    //setStates((prevState) => ({
    //    ...prevState,
    //    RowNum: 123,
    //}));
  }
  useEffect(() => {
    getListOfTickets(stSearch.searchedObject);
  }, [pagination.currentPage]);

  useEffect(() => {
    if (ticket.Tickets) {
      if (radisansupport == "true") {
        var fieldMapping = {
          seen: "",
          id: "ردیف",
          ticketId: "شماره تیکت",
          importanceGrade: "اهمیت",
          title: "دسته بندی/عنوان",
          txtWriterUserId: "از",
          txtTargetUserId: "به",
          answerStatus: "وضعیت پاسخ",
          status: "وضعیت",
          //satisfaction: "رضایتمندی",
          regDateTime: "ایجاد",
          update: "به روز رسانی",
          responseTime: "زمان اولین پاسخ",
          tag: "دسته بندی با تگ",
          // closingTime: "مدت زمان بسته شدن",
        };
      } else {
        var fieldMapping = {
          seen: "",
          id: "ردیف",
          ticketId: "شماره تیکت",
          importanceGrade: "اهمیت",
          title: "دسته بندی/عنوان",
          txtWriterUserId: "از",
          txtTargetUserId: "به",
          answerStatus: "وضعیت پاسخ",
          status: "وضعیت",
          //satisfaction: "رضایتمندی",
          regDateTime: "ایجاد",
          update: "به روز رسانی",
          // closingTime: "مدت زمان بسته شدن",
        };
      }

      var Tickets = ticket.Tickets.map((ticket, index) => {
        var dvImportant = document.createElement("div"),
          dvStatus = document.createElement("div"),
          dvAnsweredStatus = document.createElement("div"),
          dvWriterUserId = `${ticket.writerFirstName}-${ticket.writerLastName}(${ticket.writerDepartmentTitle ? "رادیسان افزار" : ticket.writerOrganizationTitle})`,
          dvTargetUserId = `${ticket.targetFirstName}-${ticket.targetLastName}(${ticket.targetDepartmentTitle ? "رادیسان افزار" : ticket.targetOrganizationTitle})`,
          dvregDateTime = document.createElement("div"),
          dvRegUpDate = document.createElement("div"),
          dvTitle = document.createElement("div"),
          dvid = document.createElement("div"),
          //dvSatisfaction = document.createElement("div"),
          dvSeen = document.createElement("div"),
          dvClass,
          dvResponseTime = document.createElement("div"),
          responseTimeText = ticket.responseTime
            ? ticket.responseTime + " دقیقه"
            : "-",
          dvstatusClass;

        var importanceGrade = "";
        var AnswerStatus = "";
        if (ticket.answerStatus == 1) {
          AnswerStatus = "پاسخ داده شده";
        } else if (ticket.answerStatus == 2) {
          AnswerStatus = "پاسخ ایجاد کننده";
        } else if (ticket.answerStatus == 3) {
          AnswerStatus = "در حال بررسی";
        }

        if (ticket.importanceGrade == 4) {
          dvClass = "success";
          importanceGrade = "پایین";
        } else if (ticket.importanceGrade == 3) {
          importanceGrade = "عادی";
          dvClass = "yellow";
        } else if (ticket.importanceGrade == 2) {
          dvClass = "warning";
          importanceGrade = "بالا";
        } else if (ticket.importanceGrade == 1) {
          dvClass = "danger";
          importanceGrade = "بحرانی";
        }

        var status = "";
        if (ticket.status) {
          status = "باز";
          dvstatusClass = "success";
        } else {
          status = "بسته";
          dvstatusClass = "danger";
          var d = new Date();
          var n = d.toLocaleTimeString();
        }
        const convertToPersian = formatDate(ticket.regDateTime);
        const updateDateConvertToPersian =
          ticket.updateDateTime >= "2000-02-28T00:00:00"
            ? formatDate(ticket.updateDateTime)
            : "-";

        dvSeen = `<div class = dvSeen><p class="black-box seenText">${
          ticket.seen ? "دیده شده" : "دیده نشده"
        }</p><img style="width: 18px;" src=${
          ticket.seen ? letterOpen : letterClose
        }></img></div>`;
        var ImportantVar =
          `<div class="badge ${dvClass}">${importanceGrade}</div>`.toElements()[0];
        var StatusVar =
          `<div class="badge ${dvstatusClass}">${status}</div>`.toElements()[0];
        var AnswerStatusVar = `<div>${AnswerStatus}</div>`.toElements()[0];
        var regDateTimeVar =
          `<div>${convertToPersian[0]}</div>`.toElements()[0];
        var regUpDateVar =
          `<div>${updateDateConvertToPersian[0]}</div>`.toElements()[0];
        //var satisfactionVar = `<div>-</div>`.toElements()[0];
        var idVar = `<div data-id=${
          index + 1
        } style="color:#337ab7;cursor: pointer;">${
          index + 1
        }</div>`.toElements()[0];
        var responseTimeVar = `<div>${responseTimeText}</div>`.toElements()[0];
        var TitleVar = `<div data-id=${index + 1} data-title=${
          ticket.title
        } data-status=${
          ticket.status
        } class="flexRow" style="justify-content: flex-start;align-items: baseline;flex-wrap: nowrap;color:#337ab7;height: 30px;width: max-content;cursor: pointer;"><p class="circle" style="background : ${
          ticket.background
        }"></p> ${ticket.title}</div>`.toElements()[0];

        // tag
        var dvTag = document.createElement("div");
        dvTag.style.display = "flex";
        dvTag.style.justifyContent = "center";
        dvTag.style.alignItems = "center";

        var select = document.createElement("select");

        select.className = "form-select";
        select.style.width = "150px";
        select.style.height = "34px";
        select.style.border = "1px solid #dcdfe6";
        select.style.borderRadius = "8px";
        select.style.padding = "0 10px";
        select.style.fontSize = "13px";
        select.style.cursor = "pointer";
        select.style.backgroundColor = "#fff";
        select.style.outline = "none";

        const emptyOption = document.createElement("option");
        emptyOption.value = "";
        emptyOption.innerText = "بدون تگ";
        select.appendChild(emptyOption);

        tags.forEach((t) => {
          const option = document.createElement("option");
          option.value = t.id;
          option.innerText = t.title;
          select.appendChild(option);
        });

        select.value = ticket.tagId ?? "";

        dvTag.appendChild(select);

        // var dvTag = document.createElement("div");

        // var select = document.createElement("select");

        // select.className = "form-control";
        // const emptyOption = document.createElement("option");
        // emptyOption.value = "";
        // emptyOption.innerText = "بدون تگ";
        // select.appendChild(emptyOption);
        // tags.forEach((t) => {
        //   var option = document.createElement("option");

        //   option.value = t.id;
        //   option.innerText = t.title;

        //   if (ticket.tagId === t.id) option.selected = true;

        //   select.appendChild(option);
        // });
        select.addEventListener("change", (e) => {
          submitTag(
            ticket.ticketId,
            e.target.value === "" ? null : Number(e.target.value),
          );
        });
        [TitleVar, idVar].forEach((dv) => {
          dv.addEventListener("click", (e) => {
            var dataid = e.currentTarget.getAttribute("data-id"),
              dataStatus = e.currentTarget.getAttribute("data-status"),
              dataTitle = e.currentTarget.getAttribute("data-title");
            navigateToTicketDetails(
              ticket,
              dataid,
              dataStatus,
              dataTitle,
              ticket.openTicketDateTime,
              ticket.updateDateTime,
            );
            setTicket((prev) => ({
              ...prev,
              ticketId: ticket.ticketId,
              dataTitle: dataTitle,
              openTicketDateTime: ticket.openTicketDateTime,
              updateDateTime: ticket.updateDateTime,
              dataStatus: dataStatus,
              answerStatus: ticket.answerStatus,
              WriterUserInfo: {
                writerDepartmentTitle: ticket.writerDepartmentTitle,
                writerOrganizationWebsite: ticket.writerOrganizationWebsite,
                writerOrganizationTitle: ticket.writerOrganizationTitle,
                writerOrganizationPhone: ticket.writerOrganizationPhone,
                writerOrganizationAddress: ticket.writerOrganizationAddress,
                writerUserRole: ticket.writerUserRole,
                writerUserId: ticket.writerUserId,
                writerReferenceType: ticket.writerReferenceType,
                writerReferenceId: ticket.writerReferenceId,
                writerMobileNo: ticket.writerMobileNo,
                writerLastName: ticket.writerLastName,
                writerFirstName: ticket.writerFirstName,
              },
              TargetUserInfo: {
                targetDepartmentTitle: ticket.targetDepartmentTitle,
                targetOrganizationWebsite: ticket.targetOrganizationWebsite,
                targetOrganizationTitle: ticket.targetOrganizationTitle,
                targetOrganizationPhone: ticket.targetOrganizationPhone,
                targetOrganizationAddress: ticket.targetOrganizationAddress,
                targetUserRole: ticket.targetUserRole,
                targetUserId: ticket.targetUserId,
                targetReferenceType: ticket.targetReferenceType,
                targetReferenceId: ticket.targetReferenceId,
                targetMobileNo: ticket.targetMobileNo,
                targetLastName: ticket.targetLastName,
                targetFirstName: ticket.targetFirstName,
              },
            }));
          });
        });
        setStates((prev) => ({
          ...prev,
          reciverUser: Array.isArray(prev.reciverUser)
            ? [
                ...prev.reciverUser,
                `${ticket.targetFirstName}-${ticket.targetLastName}-${ticket.targetUserId}`,
              ]
            : [
                `${ticket.targetFirstName}-${ticket.targetLastName}-${ticket.targetUserId}`,
              ],

          reciverUserMoreInfo: Array.isArray(prev.reciverUserMoreInfo)
            ? [
                ...prev.reciverUserMoreInfo,
                {
                  targetDepartmentTitle: ticket.targetDepartmentTitle,
                  targetOrganizationWebsite: ticket.targetOrganizationWebsite,
                  targetOrganizationTitle: ticket.targetOrganizationTitle,
                  targetOrganizationPhone: ticket.targetOrganizationPhone,
                  targetOrganizationAddress: ticket.targetOrganizationAddress,
                  targetUserRole: ticket.targetUserRole,
                  targetUserId: ticket.targetUserId,
                  targetReferenceType: ticket.targetReferenceType,
                  targetReferenceId: ticket.targetReferenceId,
                  targetMobileNo: ticket.targetMobileNo,
                  targetLastName: ticket.targetLastName,
                  targetFirstName: ticket.targetFirstName,
                },
              ]
            : [
                {
                  targetDepartmentTitle: ticket.targetDepartmentTitle,
                  targetOrganizationWebsite: ticket.targetOrganizationWebsite,
                  targetOrganizationTitle: ticket.targetOrganizationTitle,
                  targetOrganizationPhone: ticket.targetOrganizationPhone,
                  targetOrganizationAddress: ticket.targetOrganizationAddress,
                  targetUserRole: ticket.targetUserRole,
                  targetUserId: ticket.targetUserId,
                  targetReferenceType: ticket.targetReferenceType,
                  targetReferenceId: ticket.targetReferenceId,
                  targetMobileNo: ticket.targetMobileNo,
                  targetLastName: ticket.targetLastName,
                  targetFirstName: ticket.targetFirstName,
                },
              ],
        }));

        dvImportant.appendChild(ImportantVar);
        dvAnsweredStatus.appendChild(AnswerStatusVar);
        dvStatus.appendChild(StatusVar);
        //dvSatisfaction.appendChild(satisfactionVar);
        dvregDateTime.appendChild(regDateTimeVar);
        dvRegUpDate.appendChild(regUpDateVar);
        dvTitle.appendChild(TitleVar);
        dvid.appendChild(idVar);
        if (radisansupport == "true") {
          dvResponseTime.appendChild(responseTimeVar);
          dvTag.appendChild(select);
        }

        ticket.answerStatus = dvAnsweredStatus;
        ticket.importanceGrade = dvImportant;
        ticket.status = dvStatus;
        ticket.txtWriterUserId = dvWriterUserId;
        ticket.txtTargetUserId = dvTargetUserId;
        ticket.regDateTime = dvregDateTime;
        ticket.update = dvRegUpDate;
        ticket.title = dvTitle;
        ticket.id = dvid;
        ticket.seen = dvSeen;
        if (radisansupport == "true") {
          ticket.responseTime = dvResponseTime;
          ticket.tag = dvTag;
        }

        //ticket.satisfaction = dvSatisfaction;

        return ticket;
      });
      // Tickets.paging.itemCallBack = states.Tickets;
      // Tickets.paging.pageCount = 1000;
      var grid = new DataGrid(
        Tickets,
        fieldMapping,
        {
          selectable: false,
          order: false,
          // Pager: Tickets.paging,
        },
        {
          gridAlternateRow: "#F2F2F2",
        },
        (tr) => {},
      ).appendTable(inputRefs.ListOfTickets.current);
    }
  }, [ticket.Tickets]);

  // function getMainProduct(ListProduct = {}) {
  //   CallServiceExternal(`Category/GetMainCategory`, null, "Get", false, false)
  //     .then((res) => {
  //       setMainCategory(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }
  // useEffect(() => {
  //   getMainProduct();
  // });

  async function navigateToTicketDetails(
    ticket,
    dataid,
    dataStatus,
    dataTitle,
    openTicketDateTime,
    updateDateTime,
  ) {
    try {
      await CallService(
        `Tickets/${ticket.ticketId}/ToggleSeen`,
        null,
        "PUT",
        false,
        false,
      );

      navigate(`${process.env.PUBLIC_URL}/TicketDetails/${ticket.ticketId}`);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  useEffect(() => {
    if (states.Page == "newTicket") {
      navigate(`${process.env.PUBLIC_URL}/NewTicket`, {
        state: {
          setShowNewResponseTicketComponent: null,
        },
      });
    }
  }, [states.Page, states.Tickets]);
  const onPrint = useReactToPrint({
    content: () => inputRefs.ListOfTickets.current,
  });
  return (
    <div>
      <div className={`${states.NewTicket ? "none" : ""}`}>
        {ticket ? (
          <div
            id="alertInfo"
            className={`alert-info ${
              ticket && ticket.ShowSuccessTxt && ticket.ShowSuccessTxt.show
                ? "alert-info-TicketHeading-show"
                : "alert-info-TicketHeading-hide"
            }`}
          >
            <strong>اطلاعات !</strong>
            <div className="d-flex">
              <span
                id="panel-heading-span"
                onClick={() => {
                  setTicket((prevState) => ({
                    ...prevState,
                    ShowSuccessTxt: { show: false, txt: "" },
                  }));
                }}
              >
                ×
              </span>
              <p>{ticket.ShowSuccessTxt && ticket.ShowSuccessTxt.txt}</p>
            </div>
          </div>
        ) : (
          ""
        )}

        <div id="dvTickets-heading" className="flexRow justify-content">
          <div>لیست تیکت ها</div>
          <div id="dvTickets-items" className="primary">
            <div
              onClick={() => {
                setStates((prevState) => ({
                  ...prevState,
                  Page: "newTicket",
                }));
              }}
            >
              تیکت جدید
            </div>
            <img
              src={searchIcon}
              onClick={() => {
                setStates((prevState) => ({
                  ...prevState,
                  ShowSearchItems: states.ShowSearchItems ? false : true,
                }));
              }}
            ></img>
            <button className="opration-btn">
              <img src={excel}></img>
            </button>
            <button className="opration-btn" onClick={onPrint}>
              <img src={print}></img>
            </button>
          </div>
        </div>
        {states.ShowSearchItems && radisansupport == "false" && (
          <Search
            showElement={showElement}
            searchHandel={getListOfTickets}
            stUser={stUser}
            stOrganizaton={stOrganizaton}
            elClass={
              states.ShowSearchItems
                ? "search-container-show"
                : "search-container-hide"
            }
            reciverUser={states.reciverUser}
            reciverUserMoreInfo={states.reciverUserMoreInfo}
            data={ticket.searchedData}
            tags={tags}
          />
        )}
        {states.ShowSearchItems && radisansupport == "true" && (
          <Search
            showElement={showElement}
            searchHandel={getListOfTickets}
            stUser={stUser}
            stOrganizaton={stOrganizaton}
            elClass={
              states.ShowSearchItems
                ? "search-container-show"
                : "search-container-hide"
            }
            reciverUser={states.reciverUser}
            reciverUserMoreInfo={states.reciverUserMoreInfo}
            data={ticket.searchedData}
            tags={tags}
          />
        )}
        <div id="listOfTickets" ref={inputRefs.ListOfTickets}></div>
        <div className="Paginate-container">
          <Pagination
            currentPage={pagination.currentPage}
            pageSize={pagination.pageSize}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}
